import React from "react";



const About = ()=>{
     return(
     
          <div className="container">

      <h1 className="text-center mt-3 pt-5 fs-1 fw-bolder mb-4">
About Code Heads Membership Program</h1> 

<div className="border-left-2 border-color-warning">
<p className="fs-5 p-2 fw-bold">Welcome to the Code Heads Membership Program, a dedicated platform designed specifically to manage and reward our growing community of mentors and teachers. While Code Heads Hub is where the learning happens, this site is all about supporting and celebrating the people behind it, the mentors who drive tech education forward.</p>

<p className="fs-5 p-2 fw-bold">This platform doesn’t focus on sharing knowledge directly; instead, it’s your space for managing your membership, tracking your contributions, and being rewarded through our loyalty program. As a mentor or teacher, you’ll earn points and ratings for your efforts, which will be displayed on your profile giving you recognition and showcasing your impact within the community. The more you contribute, the higher your standing becomes, helping you stand out as a trusted and valued member.</p>

<p className="fs-5 p-2 fw-bold">
  We’ve created this membership platform to provide you with tools and benefits that make your journey as a mentor more rewarding. From personalized profiles to points tracking and exclusive rewards, this space is all about giving back to those who give so much to the tech community.


So, whether you’re here to manage your membership or to see your progress and rewards, we’re excited to have you with us. Join the Code Heads Membership Program and be part of a community that values mentorship and is committed to making a difference.   
</p>

  </div>

 </div>
 )
}


 export default About;